/**
 * PlaceCoreProducersSection — "Verksamheter på platsen" (secondary).
 * Only renders when producers exist.
 */
import { Separator } from "@/components/ui/separator";
import { ProducerInlineCard } from "@/components/place/ProducerInlineCard";
import type { ProducerInline } from "@/components/place/types";

interface Props {
  producers: ProducerInline[];
}

export function PlaceCoreProducersSection({ producers }: Props) {
  if (!producers.length) return null;

  return (
    <section>
      <Separator className="mb-8" />
      <h2 className="font-display text-lg text-foreground mb-1.5">
        Verksamheter på platsen
      </h2>
      <p className="text-sm text-muted-foreground mb-4">
        Här finns verksamheter som verkar på platsen.
      </p>
      <div className="space-y-3">
        {producers.map((producer) => (
          <ProducerInlineCard key={producer.id} producer={producer} />
        ))}
      </div>
    </section>
  );
}
